import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetDeclaracionJuradaCeseActividadObjetivaAByID from "services/record/DeclaracionJuradaCeseActividadObjetiva/useGetDeclaracionJuradaCeseActividadObjetivaByID";
import useGetInfoDeclaracionJuradaCeseActividadObjetiva from "services/record/DeclaracionJuradaCeseActividadObjetiva/useGetInfoDeclaracionJuradaCeseActividadObjetiva";
import useGetDeclaracionJuradaCeseActividadObjetivaByUser from "services/record/DeclaracionJuradaCeseActividadObjetiva/useGetDeclaracionJuradaCeseActividadObjetivaByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import DeclaracionJuradaCeseActividadObjetiva from "./DeclaracionJuradaCeseActividadObjetiva";

const GridDeclaracionJuradaCeseActividadObjetiva = ({ expedienteId = null, origen = null }) => {

    const {
        getDeclaracionJuradaCeseActividadObjetivaAByID,
        loadingGetDeclaracionJuradaCeseActividadObjetivaAByID,
        statusGetDeclaracionJuradaCeseActividadObjetivaAByID
    } = useGetDeclaracionJuradaCeseActividadObjetivaAByID();

    const {
        getInfoDeclaracionJuradaCeseActividadObjetiva,
        loadingGetInfoDeclaracionJuradaCeseActividadObjetiva,
        statusGetInfoDeclaracionJuradaCeseActividadObjetiva
    } = useGetInfoDeclaracionJuradaCeseActividadObjetiva();

    const {
        dataGetDeclaracionJuradaCeseActividadObjetivaByUser,
        getDeclaracionJuradaCeseActividadObjetivaByUser,
        loadingGetDeclaracionJuradaCeseActividadObjetivaByUser,
        statusGetDeclaracionJuradaCeseActividadObjetivaByUser
    } = useGetDeclaracionJuradaCeseActividadObjetivaByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Declaración jurada cese definitivo por motivos económicos, técnicos y productivos. Estimación objetiva";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getDeclaracionJuradaCeseActividadObjetivaByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetDeclaracionJuradaCeseActividadObjetivaAByID?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaCeseActividadObjetivaAByID.status,
                statusText: statusGetDeclaracionJuradaCeseActividadObjetivaAByID.statusText
            });
        } else if (statusGetInfoDeclaracionJuradaCeseActividadObjetiva?.status) {
            setCurrentHttp({
                status: statusGetInfoDeclaracionJuradaCeseActividadObjetiva.status,
                statusText: statusGetInfoDeclaracionJuradaCeseActividadObjetiva.statusText
            });
        } else if (statusGetDeclaracionJuradaCeseActividadObjetivaByUser?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaCeseActividadObjetivaByUser.status,
                statusText: statusGetDeclaracionJuradaCeseActividadObjetivaByUser.statusText
            });
        }
    }, [
        statusGetDeclaracionJuradaCeseActividadObjetivaAByID,
        statusGetInfoDeclaracionJuradaCeseActividadObjetiva,
        statusGetDeclaracionJuradaCeseActividadObjetivaByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getDeclaracionJuradaCeseActividadObjetivaAByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoDeclaracionJuradaCeseActividadObjetiva(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetDeclaracionJuradaCeseActividadObjetivaByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetDeclaracionJuradaCeseActividadObjetivaByUser]);

    const isLoading = () => {
        return (
            loadingGetDeclaracionJuradaCeseActividadObjetivaAByID ||
            loadingGetInfoDeclaracionJuradaCeseActividadObjetiva ||
            (loadingGetDeclaracionJuradaCeseActividadObjetivaByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetDeclaracionJuradaCeseActividadObjetivaByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <DeclaracionJuradaCeseActividadObjetiva
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getDeclaracionJuradaCeseActividadObjetivaByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && currentHttp.status !== 200 && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridDeclaracionJuradaCeseActividadObjetiva;
